/**
 * Label for a campaign step that has been retired from its campaign.
 * @param {string|null|undefined} templateName Name of the step's template.
 * @param {string} campaignContentId Fallback when the template name is gone.
 * @returns {string} Display label marked as removed.
 */
export const getRemovedStepLabel = (templateName, campaignContentId) =>
  `${templateName ?? campaignContentId} (removed)`

/**
 * Label for the step of an outreach history row whose template is not loaded.
 * @param {object} item History row.
 * @param {string} [item.templateName] Name of the step's template.
 * @param {boolean} [item.isStepRemoved] Whether the step was retired.
 * @returns {string} Display label.
 */
export const getHistoryStepLabel = ({ templateName, isStepRemoved }) => {
  if (!templateName) return 'Unknown step'
  return isStepRemoved ? `${templateName} (removed)` : templateName
}
